import { render, staticRenderFns } from "./CategoryContent.vue?vue&type=template&id=af0ed8a8&scoped=true&"
import script from "./CategoryContent.vue?vue&type=script&lang=js&"
export * from "./CategoryContent.vue?vue&type=script&lang=js&"
import style0 from "./CategoryContent.vue?vue&type=style&index=0&id=af0ed8a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0ed8a8",
  null
  
)

export default component.exports